<h1>Orchestrator details:</h1>
<div *ngIf="orchestrator">
    <nz-row [nzGutter]="6">
        <nz-col [nzSpan]="4">
            <nz-statistic
                [nzValue]="orchestrator.snap.id"
                nzTitle="Id"
            ></nz-statistic>
        </nz-col>
        <nz-col [nzSpan]="4">
            <nz-statistic
                [nzValue]="orchestrator.data.State.State"
                nzTitle="State"
            ></nz-statistic>
        </nz-col>
        <nz-col [nzSpan]="4">
            <nz-statistic
                [nzValue]="orchestrator.data.Options.Type"
                nzTitle="Type"
            ></nz-statistic>
        </nz-col>
        <nz-col [nzSpan]="4">
            <nz-statistic
                [nzValue]="
                    (orchestrator.data.State.ScheduledTime | fsTimestamp)!
                "
                nzTitle="ScheduledTime"
            ></nz-statistic>
        </nz-col>
        <nz-col [nzSpan]="4">
            <nz-statistic
                [nzValue]="orchestrator.data.Options.NotifyMode"
                nzTitle="NotifyMode"
            ></nz-statistic>
        </nz-col>
    </nz-row>
    <nz-row [nzGutter]="6">
        <nz-col [nzSpan]="4">
            <nz-statistic nzValue="" nzTitle=""></nz-statistic>
        </nz-col>
        <nz-col [nzSpan]="4">
            <nz-statistic
                [nzValue]="orchestrator.data.Result?.Status"
                nzTitle="Status"
            ></nz-statistic>
        </nz-col>
        <nz-col [nzSpan]="4">
            <nz-statistic
                [nzValue]="
                    orchestrator.data.Options.Type === 'Period'
                        ? orchestrator.data.Options.Period
                        : orchestrator.data.Options.Selection
                "
                nzTitle="Type"
            ></nz-statistic>
        </nz-col>
        <nz-col [nzSpan]="4">
            <nz-statistic
                [nzValue]="
                    ((orchestrator.data.State.State === 'Finished'
                        ? orchestrator.data.State.FinishedTime!
                        : orchestrator.data.State.LastUpdateTime
                    ) | fsTimestamp)!
                "
                [nzTitle]="
                    orchestrator.data.State.State === 'Finished'
                        ? 'FinishedTime'
                        : 'LastUpdateTime'
                "
            ></nz-statistic>
        </nz-col>
        <nz-col [nzSpan]="4">
            <nz-statistic
                [nzValue]="
                    orchestrator.data.Options.RunSynchronously.toString()
                "
                nzTitle="RunSynchronously"
            ></nz-statistic>
        </nz-col>
    </nz-row>
</div>

<h1>Failed jobs:</h1>
<h2 *ngIf="failedJobs !== undefined && failedJobs.length === 0">
    None (all jobs succeed).
</h2>
<div class="content content-height">
    <nz-list class="list" [nzLoading]="failedJobs === undefined">
        <nz-list-item class="item" *ngFor="let j of failedJobs">
            <span
                class="icon"
                nz-icon
                [nzType]="
                    j.data.Result?.Status === 'Failed'
                        ? 'warning'
                        : 'check-circle'
                "
            ></span>
            <nz-list-item-meta
                nzDescription="{{ j.data.Id | jobId }} {{ j.snap.id }} {{
                    j.data.State.LastUpdateTime | fsTimestamp
                }}"
            >
                <nz-list-item-meta-title
                    >{{ j.data.Result?.Status }}:
                    {{ j.data.Result?.Message }}</nz-list-item-meta-title
                >
            </nz-list-item-meta>
            <ul nz-list-item-actions>
                <nz-list-item-action
                    ><a (click)="copyFirestoreLink(j)"
                        >Copy Firestore link</a
                    ></nz-list-item-action
                >
            </ul>
        </nz-list-item>
    </nz-list>
</div>
